import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent } from '../../../commons/abstract.component';
import { ChannelTypeEnum } from '../../../models/enum/channel.type';
import { ButtonActionsTypeEnum } from '@trendbuild/trend-z-api';

export interface WhatsAppButton {
  label: string;
  type: ButtonActionsTypeEnum;
}

type TemplateType = 'text' | 'button' | 'media';

@Component({
    selector: 'chat-wa-preview',
    templateUrl: './chat-wa-preview.v2.component.html',
    // templateUrl: './chat-wa-preview.component.html',
    styleUrls: ['./chat-wa-preview.v2.component.scss']
    // styleUrls: ['./chat-wa-preview.component.scss']
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatWaPreviewComponent extends AbstractComponent {
  @Input() title?: string = '';
  @Input() message: string = 'Digite sua mensagem...';
  @Input() footer?: string = '';
  @Input() avatarUrl: string = 'https://firebasestorage.googleapis.com/v0/b/infinite7-70f9d.appspot.com/o/blank.png?alt=media&token=fea2ea97-edbd-4589-a52e-e4b8d786be0b';
  @Input() contactName?: string = 'João da Silva';
  @Input() contactStatus?: string = 'online';
  @Input() buttons: WhatsAppButton[] = [];
  @Input() templateType: TemplateType;
  @Input() showChatFrame: boolean = true;
  @Input() mediaSrc?: string;
  currentTime: string = '';
  ButtonActionsTypeEnum = ButtonActionsTypeEnum;

  channelType!: ChannelTypeEnum | string;

  ngOnInit(): void {
    const now = new Date();
    this.currentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  isCloudApi(): boolean {
    return this.channelType === ChannelTypeEnum.CLOUD_API;
  }

}
